import Splide from '@splidejs/splide';
import type { Options } from '@splidejs/splide';
import { quoteSliderSplideOptions } from './splide-options';

const ROOT = '.quote-slider .quote-wrapper.splide';

function mountIfSlides(element: HTMLElement, options: Options): void {
	if (element.classList.contains('is-initialized')) {
		return;
	}
	const slides = element.querySelectorAll('.splide__list > .splide__slide');
	if (slides.length < 1) {
		return;
	}
	new Splide(element, options).mount();
}

export default function initQuoteSliderSplide(root: ParentNode = document): void {
	root.querySelectorAll(ROOT).forEach((el) => {
		mountIfSlides(el as HTMLElement, quoteSliderSplideOptions);
	});
}
